import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StanButton } from '@/components';
import { useUser } from '@/queries';
import { mainApi } from '@/lib/api';
import HeroCustomAmy from '@/assets/images/dashboard/hero-custom-amy.svg';
import styles from './AmyGregoryDashboard.module.css';

export function AmyGregoryDashboard() {
    const { user, refetchUser } = useUser();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleUseTemplate = useCallback(async () => {
        if (!user?.user_id || !user?.referrer_user_id || !user?.username) return;

        setIsLoading(true);
        const payload = {
            referrer_user_id: user.referrer_user_id,
            user_id: user.user_id,
            username: user.username,
        };

        const payloadForTags = {
            reference_id: user.user_id,
            name: 'onboarding_referral_use_template',
            type: 'user',
            data: {},
        };

        try {
            await Promise.all([
                mainApi.put('v1/tags', payloadForTags),
                mainApi.put('v1/users/referral_triggered/duplicate_store', payload),
            ]);

            navigate('/stores');
            await refetchUser();
        } catch (error) {
            console.error('Error occurred while calling the API:', error);
        } finally {
            setIsLoading(false);
        }
    }, [user?.user_id, user?.referrer_user_id, user?.username, navigate, refetchUser]);

    const handleStartFromScratch = useCallback(async () => {
        if (!user?.user_id) return;

        setIsLoading(true);
        const payload = {
            reference_id: user.user_id,
            name: 'onboarding_referral_start_from_scratch',
            type: 'user',
            data: {},
        };

        try {
            // Optimistically update local tags (React Query will handle cache update on refetch)
            // Make the API call
            await mainApi.put('v1/tags', payload);
            // Refetch user to get updated data
            await refetchUser();
        } catch (error) {
            console.error('Error occurred while setting start from scratch tag:', error);
        } finally {
            setIsLoading(false);
        }
    }, [user?.user_id, refetchUser]);

    return (
        <div className={styles.container}>
            <div className={styles.contentWrapper}>
                <img
                    src='https://assets.stanwith.me/live/msc/26025569/ipcrs/img5675%203.jpg/webp/433x0/100/img5675%203.webp?width=500'
                    alt='Amy Gregory'
                    className={styles.mobileHeaderImage}
                />
                <div className={styles.textSection}>
                    <h1 className={styles.headline}>Use Amy Gregory&apos;s template?</h1>
                    <p className={styles.bodyText}>
                        Hi! We noticed that you signed up via Amy Gregory or her partners&apos; referral link.
                        We&apos;re ready to pre-populate your store with her recommended template! Are you in?!
                    </p>
                    <div className={styles.buttonGroup}>
                        <StanButton
                            className={styles.useTemplateButton}
                            color='primary'
                            size='xl'
                            name='use-amy-template-button'
                            onClick={handleUseTemplate}
                            loading={isLoading}
                        >
                            Use Amy&apos;s Template
                        </StanButton>
                        <button
                            className={styles.startFromScratchLink}
                            onClick={handleStartFromScratch}
                            name='start-from-scratch-link'
                            disabled={isLoading}
                        >
                            Start from Scratch
                        </button>
                    </div>
                </div>
                <div className={styles.imageSection}>
                    <HeroCustomAmy className={styles.heroImage} />
                </div>
            </div>
        </div>
    );
}
